"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLang = void 0;
exports.createLang = createLang;
const intlFunctions_1 = require("../intlFunctions");
const cachedLang = {};
function createLang(name) {
    var _a, _b;
    let result = cachedLang[name];
    if (result) {
        return result;
    }
    result = {
        name,
        weekdays: (0, intlFunctions_1.getDayNamesForLocale)(name),
        weekdaysShort: (0, intlFunctions_1.getDayNamesForLocale)(name, 'short'),
        weekdaysMin: (0, intlFunctions_1.getDayNamesForLocale)(name, 'narrow'),
        weekStart: 1,
        yearStart: 4,
        months: (0, intlFunctions_1.getMonthsForLocale)(name),
        monthsShort: (0, intlFunctions_1.getMonthsForLocale)(name, 'short'),
        ordinal: (n) => n.toString(),
        decimalSeparator: (_a = (0, intlFunctions_1.getSeparator)(name, 'decimal')) !== null && _a !== void 0 ? _a : '.',
        groupSeparator: (_b = (0, intlFunctions_1.getSeparator)(name, 'group')) !== null && _b !== void 0 ? _b : ' ',
        shortDateFormatter: (0, intlFunctions_1.getFormatDateFunction)(name),
        longDateFormatter: Intl.DateTimeFormat(name, { dateStyle: 'long' }).format,
        shortDateReformatter: (0, intlFunctions_1.getReformatDateFunction)(name),
        formatSpaceNumber: Intl.NumberFormat(name, { maximumFractionDigits: 2 }).format,
        formats: {
            // abbreviated format options allowing localization
            LTS: (0, intlFunctions_1.getTimeFormat)(name, 'medium'), // 'h:mm:ss A',
            LT: (0, intlFunctions_1.getTimeFormat)(name, 'short'), // 'h:mm A',
            L: (0, intlFunctions_1.getDateFormat)(name) // 'MM/DD/YYYY',
            /*
                  LL: 'MMMM D, YYYY',
                  LLL: 'MMMM D, YYYY h:mm A',
                  LLLL: 'dddd, MMMM D, YYYY h:mm A',
                  // lowercase/short, optional formats for localization
                  l: 'D/M/YYYY',
                  ll: 'D MMM, YYYY',
                  lll: 'D MMM, YYYY h:mm A',
                  llll: 'ddd, MMM D, YYYY h:mm A'
                  */
        },
        relativeTime: {
            // relative time format strings, keep %s %d as the same
            future: 'in %s', // e.g. in 2 hours, %s been replaced with 2hours
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours', // e.g. 2 hours, %d been replaced with 2
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        meridiem: ( /*hour, minute, isLowercase*/) => ''
    };
    cachedLang[name] = result;
    return result;
}
exports.defaultLang = {
    current: createLang('pl'),
    setLang(name) {
        this.current = createLang(name);
    }
};
/*
export var currentLang = defaultLang.current;

Object.defineProperty(module.exports, "currentLang", {
    configurable: true,
    enumerable: true,
    get() {
        return defaultLang.current
    }
})
*/
//# sourceMappingURL=lang.js.map